<template>
  <div class="mapContainer">
    <div class="map" id="map" ref="map"></div>
    <div class="measure" @click="toMeasure"></div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
// import MapboxLanguage from "@mapbox/mapbox-gl-language"; // 设置中文语言包
// import Measure from "./measure";
import { Baidu_GPS } from "../../../utils/coord";
import "mapbox-gl/src/css/mapbox-gl.css";
// import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";

export default {
  name: "Map",

  data() {
    return {
      map: null,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.initMap();
      const currentTime = new Date();
      console.log(currentTime); // 打印完整的日期和时间
    });
  },
  watch: {
    "$store.getters.sideNavOpen": {
      handler(newValue, old) {
        setTimeout(() => {
          if (this.map) {
            this.map.resize();
          }
        }, 500);
      },
    },
  },
  methods: {
    async getLonLat() {
      this.$message.info(this.$t("public.getLocal"));
      // window._Geolocation.getCurrentPosition((res) => {
      //   let coords = Baidu_GPS(res.latitude, res.longitude);
      //   res.coords = {
      //     longitude: coords.lon,
      //     latitude: coords.lat,
      //   };
      //   console.log(res.coords.longitude, res.coords.latitude, "res.coords.longitude, res.coords.latitude")
      //   this.map.setCenter([res.coords.longitude, res.coords.latitude]);
      // });
      if (navigator.geolocation) {
        console.log(111111)
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            console.log('当前位置:', latitude, longitude);
            this.map.setCenter([longitude, latitude]);
            // this.$message.success(this.$t('public.localSuccess'));
          },
          (error) => {
            console.error('获取位置失败:', error.message);
            // this.$message.error(this.$t('public.localFail'));
          },
          {
            enableHighAccuracy: true,
            timeout: 60000,
            maximumAge: 0
          }
        );
      } else {
        console.error('浏览器不支持Geolocation');
        // this.$message.error(this.$t('public.browserNotSupport'));
      }
    },
    async initMap() {
      mapboxgl.accessToken =
        "pk.eyJ1IjoiaHllb25namlua2ltIiwiYSI6ImNpZXh4dXp5eDA2YjFzaGtyOGR2dnBza2oifQ.a5K673tSr0cOcYoX1rpPhg";
      this.map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/streets-v12",
        // style: 'mapbox://styles/mapbox/light-v11',
        // style: 'mapbox://styles/mapbox/satellite-streets-v12',
        projection: "mercator", // 墨卡托投影（平铺地图）
        center: [121.32417, 31.16974],
        zoom: 6,
        maxZoom: 15, // 最大缩放
        minZoom: 0, // 最小缩放
        pitch: 0, //地图的角度，不写默认是0，取值是0-60度，一般在3D中使用
        bearing: 0, //地图的初始方向，值是北的逆时针度数，默认是0，即是正北
        antialias: true, //抗锯齿，通过false关闭提升性能
        // ...this.initOption,
      });
      this.map.on("load", () => {
        this.map.addControl(
          new mapboxgl.ScaleControl({
            maxWidth: 100,
            unit: "metric",
          }),
          "bottom-right"
        );
        // this.initMeasureTool(); // 初始化测量工具
        // this.map.addControl(new mapboxgl.NavigationControl(), "bottom-left"); // 地图控件 先隐藏掉
        this.map.doubleClickZoom.disable(); // 禁止鼠标双击缩放
        this.addMethods();
        this.getLonLat(); // 获取初始位置
      });
      this.map.on("style.load", () => {
        this.$emit("styleLoad");
      });
      //   this.map.addControl(new MapboxLanguage({ defaultLanguage: "zh-Hans" }));
    },
    // 测距
    toMeasure() {
      this.$emit("toMeasure");
    },
    addMethods() {
      // this.map.tp = new this.$trackPlay().init(false, 0.2);
      // this.map.tp = new TrackPlay(false, 0.2);
      // this.map._loadImage = (image) => {
      //   return new Promise((resolve, reject) => {
      //     this.map.loadImage(image, (error, image) => {
      //       if (error) {
      //         resolve({
      //           success: false,
      //           error,
      //         });
      //       } else {
      //         resolve({
      //           success: true,
      //           data: image,
      //         });
      //       }
      //     });
      //   });
      // };

      // // 组件转html
      // this.map._vmToPopup = this.handlerVMToPopup;
      // this.map.updateSize = () => {
      //   this.map.resize();
      // };

      // this.map.getUUID = this.getUUID;
      this.$emit("load", this.map);
    },
  },
};
</script>

<style lang="scss" scoped>
.mapContainer {
  width: 100%;
  height: 100%;
  position: relative;
  .map {
    height: 100%;
  }
  .measure {
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 25px;
    height: 25px;
    background-color: #000;

    // background: url("../../../assets//images//public/measure.png");
    // background-size: 100% 100%;
    mask: url("../../../assets//images//public/measure.png");
    mask-size: 100% 100%;
    cursor: pointer;
  }
  ::v-deep {
    .mapboxgl-ctrl.mapboxgl-ctrl-attrib {
      display: none;
    }
  }
}
</style>